import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  BasicDetailEntWantToGrow,
  Currency,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import { useTranslation } from "react-i18next";
import { Label } from "../../../Common/Label/Label";
import "react-intl-tel-input/dist/main.css";
import HelperService from "../../../../Services/HelperService";
import WebService from "../../../../Services/WebService";
import { toast } from "react-toastify";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import ErrorComponent from "../../../Common/ErrorComponent";
import Select from "react-dropdown-select";
import {
  ACCOUNT_TYPE_API,
  DROPDOWNTYPES,
} from "../../../../assets/constants/constants";
import {
  dropdownApiNewcall,
  getProfileJourneyInfo,
  isMobileNumberValid,
  getCountryListAPiCall,
} from "../../../../Services/CommonFunction";
import PhoneInput1 from "../../../PhoneInput/PhoneInput1";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import { useLocation } from "react-router-dom";
import { MdVerifiedUser } from "react-icons/md";
import Select1 from "react-select";
import CurrencySelect from "../../../Common/CurrencyDropDown/CurrencyDropdwon";
import { useDispatch, useSelector } from "react-redux";
import { storePrefferedCurrency } from "../../../../config/action";
import GoogleAddressSearch from "../../../GoogleAddressSearch/GoogleAddressSearch";
import PasswordInput, { validatePassword } from "../../../Common/PasswordInput";
import { isWarning } from "../../Helper";
import VerifyMobileOTP from "../../../Profile/VerifyMobile";
import ChangeMobileNumberModal from "../../../Profile/ChangeMobileNumber";
import ChangeEmailModal from "../../../Profile/ChangeEmail";
import VerifyEmailOTP from "../../../Profile/VerifyEmailOTP";

interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from?: string;
  disabled?: boolean;
  fields_to_improve?: any;
}

const types = [
  DROPDOWNTYPES.TYPE_OF_PARTICIPANT,
  DROPDOWNTYPES.PRIMARY_OBJECTIVE,
  DROPDOWNTYPES.OPERATIONAL_REGION,
];
const BasicDetailsWantToGrow = ({
  handleNext,
  impIds,
  from,
  fields_to_improve,
}: PropsData) => {
  let login_type = impIds?.login_type ?? "";
  let account_type = impIds?.account_type ?? "";
  let location = useLocation();
  let status = location?.state?.disable;
  const selectedCurrency: Currency = useSelector(
    (state: any) => state?.items?.storedPrefferedCurrency,
  );
  const { t } = useTranslation();
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  const [countryOptions, setCountryOptions] = useState<{ label: string; value: string }[]>([]);
  const [emailVerifiedAt, setEmailVerifiedAt] = useState(false);
  const [isManualAddress, setIsManualAddress] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [showEmailOTPVerify, setShowEmailOTPVerify] = useState(false);
  const [basicDetails, setBasicDetails] = useState<BasicDetailEntWantToGrow>({
    company_name: "",
    first_name: "",
    email: "",
    dial_code: "",
    country_code: "",
    mobile_number: "",
    login_type: login_type?.toLocaleUpperCase(),
    account_type: account_type?.toLocaleUpperCase(),
    website_portfolio_link: "",
    profile_photo: "",
    city: "",
    pincode: "",
    location: "",
    contact_designation: "",
    contact_dial_code: "",
    contact_email: "",
    contact_person_name: "",
    contact_phone_number: "",
    country: "",
    last_name: "",
    operational_region: [],
    primary_objective: "",
    type_of_participant: "",
    preferred_currency: selectedCurrency ? selectedCurrency?.code : "",
    primary_objective_other: "",
    type_of_participant_other: "",
  });
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);
  const [showOTPVerify, setShowOTPVerify] = useState(false);
  const [showChangeMobileModal, setShowChangeMobileModal] = useState(false);
  let dispatch = useDispatch();
  const [dial_code, setdial_Code] = useState("");
  const [mobile_number, setMoible_number] = useState("");
  const [country_code, setCountryCode] = useState("");
  const [apiCallTriggered, setAPICallTriggered] = useState(false);

  const isMobileVerified = Boolean(
    basicDetails?.mobile_verified_at &&
    basicDetails?.mobile_verified_at !== "null"
  );

  const getCleanMobile = (mobile?: string, dialCode?: string) => {
    if (!mobile) return "";
    let s = String(mobile).trim();
    if (!s || s === "-" || s === "null" || s === "undefined") return "";
    const dial = String(dialCode || "").trim();
    if (dial && s.startsWith(dial)) {
      s = s.slice(dial.length).trim();
    }
    const dialWithPlus = dial ? (dial.startsWith("+") ? dial : `+${dial}`) : "";
    if (dialWithPlus && s.startsWith(dialWithPlus)) {
      s = s.slice(dialWithPlus.length).trim();
    }
    return s.replace(/\D/g, "");
  };

  const hasMobileNumber = Boolean(
    getCleanMobile(basicDetails?.mobile_number, basicDetails?.dial_code).length >= 4
  );

  useEffect(() => {
    if (impIds?.uuid) {
      getBasicDetails();
    }
  }, []);
  useEffect(() => {
    loadDropdowns();
  }, []);
  const stored_password = sessionStorage.getItem("temp_password");
  let locationVar = useLocation();
  const socialData = locationVar?.state?.social_data;

  useEffect(() => {
    if (socialData) {
      setBasicDetails((prev: BasicDetailEntWantToGrow) => ({
        ...prev,
        // split name if needed
        first_name: socialData?.name?.split(" ")[0] || "",
        last_name: socialData?.name?.split(" ").slice(1).join(" ") || "",

        email: socialData?.email || "",

        // optional (if you store provider info)
        login_field: socialData?.provider,
        social_id: socialData?.provider_id,
      }));

      // optionally mark email verified
      // setEmailVerifiedAt(true);
    }
  }, [socialData]);
  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("want-to-grow", types); // types is an array of expected keys
      const formattedData: Record<string, { label: string; value: any }[]> = {};
      types.forEach((type) => {
        const items = res[type];
        if (Array.isArray(items)) {
          formattedData[type] = items.map((item) => ({
            label: item.title,
            value: item.title,
          }));
        }
      });

      setDropdownData(formattedData);

      const countries = await getCountryListAPiCall("");
      if (Array.isArray(countries)) {
        const formattedCountries = countries.map((c: any) => {
          const countryName = c.title || c.name || "";
          return {
            label: countryName,
            value: countryName,
          };
        });
        setCountryOptions(formattedCountries);
      }
    } catch (error) { }
  }

  const getBasicDetails = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `get-detail/${impIds?.uuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          let businessInfo = res?.info?.business_info;
          let entrepreneur_business_details =
            businessInfo?.entrepreneur_business_details;
          if (info) {

            setBasicDetails((prevBasicDetails: BasicDetailEntWantToGrow) => ({
              ...prevBasicDetails,
              company_name: info?.companies?.company_name || info?.company_name || entrepreneur_business_details?.company_name || "",
              first_name: info?.first_name,
              last_name: info?.last_name,
              mobile_number: info?.mobile_number ?? "",
              dial_code: info?.dial_code,
              country_code: info?.country_code,
              email: info?.email,
              location: entrepreneur_business_details?.location,
              website_portfolio_link:
                entrepreneur_business_details?.website_portfolio_link,
              city: businessInfo?.entrepreneur_business_details?.city,
              country: businessInfo?.entrepreneur_business_details?.country,
              pincode: entrepreneur_business_details?.pincode,
              preferred_currency: info?.preferred_currency,
              contact_person_name:
                entrepreneur_business_details?.contact_person_name,
              contact_phone_number:
                entrepreneur_business_details?.contact_phone_number,
              contact_dial_code:
                entrepreneur_business_details?.contact_dial_code,
              contact_designation:
                entrepreneur_business_details?.contact_designation,
              contact_email: entrepreneur_business_details?.contact_email,
              operational_region:
                entrepreneur_business_details?.operational_region,
              primary_objective:
                entrepreneur_business_details?.primary_objective,
              type_of_participant:
                entrepreneur_business_details?.type_of_participant,
              primary_objective_other:
                entrepreneur_business_details?.primary_objective_other,
              type_of_participant_other:
                entrepreneur_business_details?.type_of_participant_other,
              password:
                from !== "REVIEW" && impIds?.business_uuid
                  ? stored_password || ""
                  : "",
              mobile_verified_at: info?.mobile_verified_at,
            }));
            setEmailVerifiedAt(res?.info?.email_verified_at ? true : false);
            setCountryCode(info?.country_code);
            setdial_Code(info?.dial_code);
            setMoible_number(info?.mobile_number ?? "");
            // setMobileVerifiedat(res?.info?.mobile_verified_at ? true : false);
            if (info?.currency) {
              dispatch(storePrefferedCurrency(info?.currency));
            }
          }
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleChange = (name: string, value: string) => {
    // const { name, value } = e.target;
    setBasicDetails((prevBasicDetails: BasicDetailEntWantToGrow) => ({
      ...prevBasicDetails,
      [name]: value,
    }));
  };
  const handleSaveBasicDetails = (flag: boolean) => {
    if (
      HelperService?.checkFormEmptyFields(basicDetails, [
        "login_type",
        "company_name",
        "profile_photo",
        "website_portfolio_link",
        "type_of_participant_other",
        "primary_objective_other",
        "pincode",
        "password",
        "country_code",
        "state",
        "contact_phone_number",
        "contact_dial_code",
        "mobile_number",
        "dial_code",
        "country_code",
        "primary_objective",
        "contact_designation",
        "social_id",
        "mobile_verified_at",
        "type_of_participant",
        "contact_person_name",
        "contact_email",
        "latitude",
        "longitude",
      ]) ||
      (basicDetails?.type_of_participant === "Other" &&
        !basicDetails?.type_of_participant_other) ||
      (basicDetails?.primary_objective === "Other" &&
        !basicDetails?.primary_objective_other) ||
      (!basicDetails?.operational_region ||
        basicDetails?.operational_region?.length === 0)
    ) {
      setErrorFlag(true);
      return;
    } else if (
      basicDetails?.website_portfolio_link &&
      !HelperService.isValidSocialUrl(basicDetails?.website_portfolio_link)
    ) {
      setErrorFlag(true);
      return;
    } else if (
      basicDetails?.contact_email &&
      !HelperService.isValidEmail(basicDetails?.contact_email)
    ) {
      setErrorFlag(true);
      return;
    } else if (
      (!basicDetails?.password || !validatePassword(basicDetails?.password)) &&
      from !== "REVIEW" &&
      from !== "FROM_PROFILE_ANALYSIS"
    ) {
      setErrorFlag(true);
      return;
    } else {
      setErrorFlag(false);
    }
    if (impIds?.business_uuid) {
      handleUpdateBasicDetailsApiCall(flag);
    } else {
      handleSaveBasicDetailsApiCall(flag);
    }
  };
  const { FCMDeviceToken } = useSelector((state: any) => state.items);

  const handleSaveBasicDetailsApiCall = (flag: boolean) => {
    const resolvedCountryCode =
      basicDetails?.country_code ||
      country_code ||
      null;

    const cleanMobile = HelperService.removeDialCode(
      basicDetails?.mobile_number,
      basicDetails?.dial_code,
    );
    const hasValidMobile = Boolean(cleanMobile && cleanMobile.length >= 4);

    let updatedata = {
      ...basicDetails,
      country_code: resolvedCountryCode,
      mobile_number: hasValidMobile ? cleanMobile : null,
      dial_code: hasValidMobile ? basicDetails?.dial_code : null,
      device_token: FCMDeviceToken,
    };
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);
    return WebService.postAPI({
      action: `basic-detail/${account_type}`,
      body: updatedata,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          if (
            !res?.mobile_verification_required &&
            !res?.email_verification_required
          )
            toast.success(res.message);

          handleNext(
            res,
            basicDetails?.email,
            hasValidMobile ? cleanMobile : null,
            hasValidMobile ? basicDetails?.dial_code : null,
            res?.mobile_verification_required,
            res?.email_verification_required,
            resolvedCountryCode,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };
  const handleUpdateBasicDetailsApiCall = (flag: boolean) => {
    const resolvedCountryCode =
      basicDetails?.country_code ||
      country_code ||
      null;

    const cleanMobile = HelperService.removeDialCode(
      basicDetails?.mobile_number,
      basicDetails?.dial_code,
    );
    const hasValidMobile = Boolean(cleanMobile && cleanMobile.length >= 4);

    let updatedata = {
      ...basicDetails,
      country_code: resolvedCountryCode,
      mobile_number: hasValidMobile ? cleanMobile : null,
      dial_code: hasValidMobile ? basicDetails?.dial_code : null,
    };
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);
    return WebService.putAPI({
      action: `basic-detail/${ACCOUNT_TYPE_API.WANT_TO_GROW}/${impIds?.uuid}/${impIds?.business_uuid}`,
      body: updatedata,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          if (
            // !res?.mobile_verification_required &&
            !res?.email_verification_required
          )
            toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(
            res,
            basicDetails?.email,
            hasValidMobile ? cleanMobile : null,
            hasValidMobile ? basicDetails?.dial_code : null,
            // res?.mobile_verification_required,
            res?.email_verification_required,
            resolvedCountryCode,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };

  const handlePhoneChange = (value: any, countryData: any) => {
    const iso = countryData?.iso2 || countryData?.countryCode || "";
    setBasicDetails((prevBasicDetails: BasicDetailEntWantToGrow) => ({
      ...prevBasicDetails,
      dial_code: countryData?.dialCode || prevBasicDetails.dial_code,
      mobile_number: value,
      country_code: iso || prevBasicDetails.country_code || null,
    }));
    if (iso) {
      setCountryCode(iso);
    }
  };
  const handleContactPhoneChange = (value: any, countryData: any) => {
    setBasicDetails((prevBasicDetails: BasicDetailEntWantToGrow) => ({
      ...prevBasicDetails,
      contact_dial_code: countryData?.dialCode,
      contact_phone_number: value,
    }));
  };

  const handleArrayValueChange = (value: any[], key: string) => {
    setBasicDetails((prevDetails: BasicDetailEntWantToGrow) => ({
      ...prevDetails,
      [key]: Array.isArray(prevDetails[key as keyof BasicDetailEntWantToGrow])
        ? value.map((item) => ({ title: item?.value }))
        : value[0]?.value,
    }));
  };
  const handleSendOTP = () => {
    WebService.addLoader("verify-otp");
    const isProfileMode = from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS";
    const apiCall = isProfileMode ? WebService.postAPI : WebService.beforeLoginPostAPI;
    const action = isProfileMode ? "verify-mobile/send-otp" : "otp/resend";

    return apiCall({
      action: action,
      body: {
        login_field: "MOBILE_NUMBER",
        mobile_number: HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        ),
        email: basicDetails?.email,
        dial_code: basicDetails?.dial_code,
        country_code: basicDetails?.country_code,
      },
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          setShowOTPVerify(true);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
      })
      .finally(() => {
        WebService.removeLoader("verify-otp");
      });
  };
  return (
    <>
      <div className="login-form w-100 px-0 position-relative">
        {loader ? <CompoLoader /> : null}
        <div className="custom-title my-auto font-bold mb-2">
          Business/Individual Information
        </div>

        <CommonScrollbar height={from === "REVIEW" ? "auto" : "65vh"}>
          <div className="p-2 me-2">
            <div className="mb-2 d-flex gap-1">
              <div className="w-50">
                <RequiredLabel isRequired={true}>First Name</RequiredLabel>

                <Form.Control
                  type="text"
                  placeholder="First Name"
                  name="first_name"
                  disabled={
                    from === "REVIEW" ||
                    from === "FROM_PROFILE_ANALYSIS" ||
                    status
                  }
                  value={basicDetails?.first_name}
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  className={
                    (!basicDetails?.first_name && skipButtonClicked) ||
                      isWarning(fields_to_improve, "first_name")
                      ? "warning-field"
                      : ""
                  }
                />
                {!skipButtonClicked && errorFlag && !basicDetails?.first_name && (
                  <Label title="Please enter first name" modeError={true} />
                )}
              </div>
              <div className="w-50">
                <RequiredLabel isRequired={true}>Last Name</RequiredLabel>

                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  name="last_name"
                  disabled={
                    from === "REVIEW" ||
                    from === "FROM_PROFILE_ANALYSIS" ||
                    status
                  }
                  value={basicDetails?.last_name}
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  className={
                    (!basicDetails?.last_name && skipButtonClicked) ||
                      isWarning(fields_to_improve, "last_name")
                      ? "warning-field"
                      : ""
                  }
                />
                {!skipButtonClicked && errorFlag && !basicDetails?.last_name && (
                  <Label title="Please enter last name" modeError={true} />
                )}
              </div>
            </div>

            <div className="mb-2 w-100">
              <RequiredLabel isRequired={false}>Company Name</RequiredLabel>
              <Form.Control
                type="text"
                placeholder="Company Name"
                name="company_name"
                value={basicDetails?.company_name || ""}
                onChange={(e) =>
                  handleChange(e?.target?.name, e?.target?.value)
                }
              />
            </div>

            <div className="d-flex gap-1 mb-1">
              <div className="mb-1 col-lg-6">
                <div className="d-flex justify-content-between">
                  <RequiredLabel isRequired={false}>Mobile Number</RequiredLabel>
                  {hasMobileNumber &&
                    (isMobileVerified ? (
                      <div className="d-flex gap-1 justify-content-end me-3">
                        <MdVerifiedUser color="green" className="" />
                        <span className="font-12 text-success">Verified</span>
                      </div>
                    ) : (
                      <span
                        id="verify-otp"
                        className="verify-otp-btn"
                        onClick={handleSendOTP}
                      >
                        Verify
                      </span>
                    ))}
                </div>
                <PhoneInput1
                  disabled={
                    from === "REVIEW" ||
                    from === "FROM_PROFILE_ANALYSIS" ||
                    status
                  }
                  value={basicDetails?.mobile_number}
                  dial_code={basicDetails?.dial_code}
                  errorFlag={errorFlag}
                  handlePhoneNumberChange={(value, countryData) =>
                    handlePhoneChange(value, countryData)
                  }
                  className={
                    isWarning(fields_to_improve, "mobile_number")
                      ? "warning-field"
                      : ""
                  }
                />

                {!hasMobileNumber &&
                  (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") ? (
                  <div className="mt-1 d-flex flex-column align-items-start gap-1">
                    <span className="na-badge" title="Incomplete - Not provided">
                      N/A
                    </span>
                    <a
                      href="#"
                      className="font-12 font-bold"
                      style={{
                        color: "#235299",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowChangeMobileModal(true);
                      }}
                    >
                      Add Mobile Number
                    </a>
                  </div>
                ) : (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") &&
                  hasMobileNumber ? (
                  <div className="d-flex justify-content-between ">
                    <div
                      className="mt-0 font-14 font-bold cursor-pointer"
                      style={{ color: "#66C15E" }}
                      onClick={() => {
                        setShowChangeMobileModal(true);
                      }}
                    >
                      Change Mobile Number
                    </div>
                  </div>
                ) : null}

                {/* {errorFlag &&
                  (!basicDetails?.mobile_number ||
                    (basicDetails.mobile_number &&
                      !isMobileNumberValid(
                        basicDetails?.mobile_number,
                        basicDetails?.dial_code
                      ))) && (
                    <Label
                      title="Please enter valid mobile number"
                      modeError={true}
                    />
                  )} */}
              </div>
              <div className="mb-2 col-lg-6">
                <div className="d-flex justify-content-between me-3">
                  <RequiredLabel isRequired={true}>
                    Official Email ID
                  </RequiredLabel>

                  {emailVerifiedAt && (
                    <div className="d-flex gap-1 justify-content-end">
                      <MdVerifiedUser color="green" className="" />
                      <span className="font-12 text-success">Verified</span>
                    </div>
                  )}
                </div>

                <Form.Control
                  type="text"
                  disabled={
                    from === "REVIEW" ||
                    from === "FROM_PROFILE_ANALYSIS" ||
                    status
                  }
                  placeholder={t("Register.enter_email")}
                  name="email"
                  value={basicDetails?.email}
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  className={
                    (!basicDetails?.email && skipButtonClicked) ||
                      isWarning(fields_to_improve, "email")
                      ? "warning-field"
                      : ""
                  }
                />

                {(from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") && (
                  <div
                    className="mt-1 font-14 font-bold cursor-pointer text-end"
                    style={{ color: "#66C15E" }}
                    onClick={() => setShowEmail(true)}
                  >
                    Change Email
                  </div>
                )}

                {((!skipButtonClicked && errorFlag && !basicDetails?.email) ||
                  (!skipButtonClicked &&
                    errorFlag &&
                    basicDetails?.email &&
                    !HelperService.isValidEmail(basicDetails?.email))) && (
                    <Label title={t("Register.invalid_email")} modeError={true} />
                  )}
              </div>
            </div>

            {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
              <>
                <PasswordInput
                  label="Password"
                  name="password"
                  value={basicDetails?.password || ""}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  required
                  strongValidate
                  className={
                    !basicDetails?.password && skipButtonClicked
                      ? "warning-field"
                      : ""
                  }
                />
                {!skipButtonClicked && !basicDetails?.password && errorFlag && (
                  <Label title="Please enter password" modeError={true} />
                )}
              </>
            )}
            <div className="w-50 mb-1">
              <RequiredLabel isRequired={true}>Preferred Currency</RequiredLabel>
              <CurrencySelect
                isDisabled={from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS" || false}
                onChange={(value: any) => {
                  if (value?.value) {
                    setBasicDetails((prev: BasicDetailEntWantToGrow) => ({
                      ...prev,
                      preferred_currency: value?.value,
                    }));
                  }
                }}
                className={
                  (!basicDetails?.preferred_currency && skipButtonClicked) ||
                    isWarning(fields_to_improve, "preferred_currency")
                    ? "warning-field"
                    : ""
                }
              />
              <ErrorComponent
                title="Please select preffered currency"
                flag={errorFlag && !skipButtonClicked}
                isArray={false}
                data={basicDetails?.preferred_currency}
              />
            </div>
            <div className="mb-2 d-flex gap-1 justify-content-between ">
              <div className="w-100">
                <GoogleAddressSearch
                  label={<RequiredLabel isRequired={true}>Head Quarter Location</RequiredLabel>}
                  mode="address"
                  value={basicDetails?.location || ""}
                  onManualToggle={(isManual: boolean) => setIsManualAddress(isManual)}
                  className={
                    (!basicDetails?.location && skipButtonClicked) ||
                      isWarning(fields_to_improve, "location")
                      ? "warning-field"
                      : ""
                  }
                  onSelect={(
                    address: string,
                    place: google.maps.places.PlaceResult,
                    geo: { lat: number | null; lng: number | null },
                  ) => {
                    handleChange("location", address);

                    handleChange(
                      "latitude",
                      geo?.lat ? geo?.lat?.toString() : "",
                    );
                    handleChange(
                      "longitude",
                      geo?.lng ? geo?.lng?.toString() : "",
                    );
                    let city = "";
                    let state = "";
                    let country = "";
                    let pincode = "";
                    let address_country_code = "";

                    if (place.address_components) {
                      for (let component of place.address_components) {
                        if (component.types.includes("locality")) {
                          city = component.long_name;
                        }
                        if (
                          component.types.includes("administrative_area_level_1")
                        ) {
                          state = component.long_name;
                        }
                        if (component.types.includes("country")) {
                          country = component.long_name;
                          address_country_code = (component.short_name || "").toLowerCase();
                        }
                        if (component.types.includes("postal_code")) {
                          pincode = component.long_name;
                        }
                      }
                    }
                    handleChange("pincode", pincode);
                    handleChange("city", city);
                    handleChange("state", state);
                    handleChange("country", country);
                    if (address_country_code) {
                      handleChange("country_code", address_country_code);
                      setCountryCode(address_country_code);
                    }
                  }}
                />

                <ErrorComponent
                  title="Please enter location"
                  flag={errorFlag && !skipButtonClicked}
                  isArray={false}
                  data={basicDetails?.location}
                />
              </div>
            </div>
            <div className="d-flex w-100 gap-1 mb-1">
              <div className="w-50">
                <RequiredLabel isRequired={true}>City</RequiredLabel>

                <Form.Control
                  type="text"
                  name="city"
                  placeholder="Enter city"
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  value={basicDetails?.city}
                  className={
                    (!basicDetails?.city && skipButtonClicked) ||
                      isWarning(fields_to_improve, "city")
                      ? "warning-field"
                      : ""
                  }
                />
                <ErrorComponent
                  title="Please enter city"
                  flag={errorFlag && !skipButtonClicked}
                  isArray={false}
                  data={basicDetails?.city}
                />
              </div>

              <div className="w-50">
                <RequiredLabel isRequired={true}>
                  Country of Registration
                </RequiredLabel>
                {!isManualAddress ? (
                  <Form.Control
                    type="text"
                    name="country"
                    placeholder="Auto-populated from address search"
                    readOnly
                    disabled
                    value={basicDetails?.country || ""}
                    className={
                      (!basicDetails?.country && skipButtonClicked) ||
                        isWarning(fields_to_improve, "country")
                        ? "warning-field"
                        : ""
                    }
                  />
                ) : (
                  <Select1
                    options={countryOptions}
                    placeholder="Select country"
                    value={
                      basicDetails?.country
                        ? { label: basicDetails.country, value: basicDetails.country }
                        : null
                    }
                    onChange={(selected: any) =>
                      handleChange("country", selected?.value || "")
                    }
                    className={
                      (!basicDetails?.country && skipButtonClicked) ||
                        isWarning(fields_to_improve, "country")
                        ? "warning-field"
                        : ""
                    }
                  />
                )}
                <ErrorComponent
                  title="Please enter country"
                  flag={errorFlag && !skipButtonClicked}
                  isArray={false}
                  data={basicDetails?.country}
                />
              </div>
            </div>
            <div className="w-50">
              <RequiredLabel isRequired={false}>Pincode</RequiredLabel>
              <Form.Control
                type="text"
                name="pincode"
                placeholder="Enter Pincode"
                onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                value={basicDetails?.pincode}
                className={
                  isWarning(fields_to_improve, "pincode") ? "warning-field" : ""
                }
              />
              {/* <ErrorComponent
              title="Please enter pincode"
              flag={errorFlag}
              isArray={false}
              data={basicDetails?.pincode}
            /> */}
            </div>
            <div className="d-flex w-100 gap-1 mb-1">
              <div className="w-50">
                <RequiredLabel isRequired={false}>
                  Contact Person Name
                </RequiredLabel>

                <Form.Control
                  type="text"
                  name="contact_person_name"
                  placeholder="Enter contact person name"
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  className={
                    isWarning(fields_to_improve, "contact_person_name")
                      ? "warning-field"
                      : ""
                  }
                  value={basicDetails?.contact_person_name}
                />
                {/* <ErrorComponent
                title="Please enter contact person name"
                flag={errorFlag}
                isArray={false}
                data={basicDetails?.contact_person_name}
              /> */}
              </div>
              <div className="w-50">
                <RequiredLabel isRequired={false}>Designation/Role</RequiredLabel>

                <Form.Control
                  type="text"
                  name="contact_designation"
                  placeholder="Enter designation"
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  className={
                    isWarning(fields_to_improve, "contact_designation")
                      ? "warning-field"
                      : ""
                  }
                  value={basicDetails?.contact_designation}
                />
                {/* <ErrorComponent
                title="Please enter designation/role"
                flag={errorFlag}
                isArray={false}
                data={basicDetails?.contact_designation}
              /> */}
              </div>
            </div>
            <div className="d-flex gap-1 mb-1">
              <div className="mb-2 col-lg-6">
                <RequiredLabel isRequired={false}>
                  Contact Mobile Number
                </RequiredLabel>
                <PhoneInput1
                  value={basicDetails?.contact_phone_number}
                  dial_code={basicDetails?.contact_dial_code}
                  errorFlag={errorFlag}
                  handlePhoneNumberChange={(value, countryData) =>
                    handleContactPhoneChange(value, countryData)
                  }
                  className={
                    isWarning(fields_to_improve, "contact_phone_number")
                      ? "warning-field"
                      : ""
                  }
                />

              </div>
              <div className="mb-2 col-lg-6">
                <RequiredLabel isRequired={false}>Contact Email ID</RequiredLabel>

                <Form.Control
                  type="text"
                  placeholder="Please enter contact email"
                  name="contact_email"
                  value={basicDetails?.contact_email}
                  onChange={(e) =>
                    handleChange(e?.target?.name, e?.target?.value)
                  }
                  className={
                    (errorFlag &&
                      basicDetails?.contact_email &&
                      !HelperService.isValidEmail(basicDetails?.contact_email)) ||
                    isWarning(fields_to_improve, "contact_email")
                      ? "warning-field"
                      : ""
                  }
                />
                {errorFlag &&
                  basicDetails?.contact_email &&
                  !HelperService.isValidEmail(basicDetails?.contact_email) && (
                    <Label title="Please enter a valid contact email" modeError={true} />
                  )}
              </div>
            </div>

            <div className="mb-2 mb-1">
              <RequiredLabel isRequired={false}>
                Website/Social Media Link
              </RequiredLabel>
              <Form.Control
                type="text"
                placeholder="Enter website/portfolio link(e.g.https://example.com)"
                name="website_portfolio_link"
                value={basicDetails?.website_portfolio_link || "https://"}
                className={
                  isWarning(fields_to_improve, "website_portfolio_link")
                    ? "warning-field"
                    : ""
                }
                onChange={(e) => {
                  let value = e.target.value;
                  if (!value.startsWith("https://")) {
                    value = "https://";
                  }
                  handleChange(e.target.name, value);
                }}
              />

              {errorFlag &&
                basicDetails?.website_portfolio_link &&
                !HelperService.isValidSocialUrl(
                  basicDetails?.website_portfolio_link,
                ) && (
                  <Label
                    title="Please enter valid social link"
                    modeError={true}
                  />
                )}
            </div>

            <div className="mb-2 w-100">
              <RequiredLabel isRequired={false}>
                Type Of Participant
              </RequiredLabel>

              <Select
                dropdownHeight="200px"
                // className="multi-select"
                options={dropdownData[DROPDOWNTYPES.TYPE_OF_PARTICIPANT] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "type_of_participant");
                  }
                }}
                className={
                  isWarning(fields_to_improve, "type_of_participant")
                    ? "warning-field"
                    : ""
                }
                labelField="label"
                valueField="value"
                name="business_industry"
                values={
                  basicDetails?.type_of_participant
                    ? [
                      {
                        value: basicDetails?.type_of_participant,
                        label: basicDetails?.type_of_participant,
                      },
                    ]
                    : []
                }
              />
              {/* <ErrorComponent
              title="Please select type of participant"
              flag={errorFlag}
              isArray={true}
              data={basicDetails?.type_of_participant}
            /> */}
            </div>
            {basicDetails?.type_of_participant === "Other" && (
              <div className="mb-2 mb-1 w-100">
                <RequiredLabel isRequired={false}>
                  Other Type Of Participant
                </RequiredLabel>
                <Form.Control
                  type="text"
                  placeholder="Enter other type of participant"
                  name="type_of_participant_other"
                  value={basicDetails?.type_of_participant_other}
                  onChange={(e) => {
                    let value = e.target.value;
                    handleChange(e.target.name, value);
                  }}
                  className={
                    isWarning(fields_to_improve, "type_of_participant_other")
                      ? "warning-field"
                      : ""
                  }
                />

                {errorFlag &&
                  !basicDetails?.type_of_participant_other &&
                  basicDetails?.type_of_participant === "Other" && (
                    <Label
                      title="Please enter other type of participant"
                      modeError={true}
                    />
                  )}
              </div>
            )}
            <div className="mb-2 w-100">
              <RequiredLabel isRequired={false}>Primary Objectives</RequiredLabel>

              <Select
                dropdownHeight="200px"
                // className="multi-select"
                options={dropdownData[DROPDOWNTYPES.PRIMARY_OBJECTIVE] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "primary_objective");
                  }
                }}
                className={
                  isWarning(fields_to_improve, "primary_objective")
                    ? "warning-field"
                    : ""
                }
                labelField="label"
                valueField="value"
                name="business_industry"
                values={
                  basicDetails?.primary_objective
                    ? [
                      {
                        value: basicDetails?.primary_objective,
                        label: basicDetails?.primary_objective,
                      },
                    ]
                    : []
                }
              />
              {/* <ErrorComponent
              title="Please select type of participant"
              flag={errorFlag}
              isArray={true}
              data={basicDetails?.primary_objective}
            /> */}
            </div>
            {basicDetails?.primary_objective === "Other" && (
              <div className="mb-2 mb-1 w-100">
                <RequiredLabel isRequired={false}>
                  Other Primary Objective
                </RequiredLabel>
                <Form.Control
                  type="text"
                  placeholder="Enter other primary objective"
                  name="primary_objective_other"
                  value={basicDetails?.primary_objective_other}
                  onChange={(e) => {
                    let value = e.target.value;
                    handleChange(e.target.name, value);
                  }}
                  className={
                    isWarning(fields_to_improve, "primary_objective_other")
                      ? "warning-field"
                      : ""
                  }
                />

                {errorFlag &&
                  !basicDetails?.primary_objective_other &&
                  basicDetails?.primary_objective === "Other" && (
                    <Label
                      title="Please enter other primary objective"
                      modeError={true}
                    />
                  )}
              </div>
            )}
            <div className="mb-1 w-100 ">
              <RequiredLabel isRequired={true}>
                Operational Regions(max 3)
              </RequiredLabel>

              <Select1
                classNamePrefix="react-select"
                menuPosition="fixed"
                options={dropdownData[DROPDOWNTYPES.OPERATIONAL_REGION] || []}
                isMulti
                menuPlacement="bottom"
                onChange={(values: any) => {
                  if (values?.length > 3) {
                    toast.warn("You can select a maximum of 3 options.");
                    return false;
                  } else handleArrayValueChange(values, "operational_region");
                }}
                name="interested_in"
                value={
                  basicDetails?.operational_region?.length > 0
                    ? basicDetails?.operational_region.map((item: any) => ({
                      value: item?.title,
                      label: item?.title,
                    }))
                    : []
                }
                className={
                  (errorFlag &&
                    (!basicDetails?.operational_region ||
                      basicDetails?.operational_region?.length === 0)) ||
                    isWarning(fields_to_improve, "operational_region")
                    ? "warning-field"
                    : ""
                }
              />

              <ErrorComponent
                title="Please select operational region"
                flag={errorFlag && !skipButtonClicked}
                isArray={true}
                data={basicDetails?.operational_region}
              />
            </div>

            <div className="mb-2 d-flex gap-2 mt-2">
              <Button
                disabled={apiCallTriggered}
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                type="button"
                id="save_basic_details"
                onClick={() => {
                  setSkipButtonClicked(false);
                  handleSaveBasicDetails(false);
                }}
              >
                {" "}
                {from && from === "REVIEW"
                  ? t("Register.save")
                  : t("Register.continue")}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  disabled={apiCallTriggered}
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_basic_details"
                  onClick={() => {
                    setSkipButtonClicked(true);
                    handleSaveBasicDetails(true);
                  }}
                >
                  Skip
                </Button>
              )}
            </div>
          </div>
        </CommonScrollbar>
        {showOTPVerify && (
          <VerifyMobileOTP
            contactInfo={{
              dial_code: basicDetails?.dial_code || dial_code,
              mobile_number: HelperService.removeDialCode(
                basicDetails?.mobile_number,
                basicDetails?.dial_code,
              ) || mobile_number,
              country_code:
                basicDetails?.country_code ||
                country_code ||
                null,
            }}
            handleHide={(flag) => {
              if (flag) {
                setBasicDetails((prev: any) => ({
                  ...prev,
                  mobile_verified_at: new Date().toISOString(),
                }));
                if (impIds?.uuid) {
                  getBasicDetails();
                }
              }
              setShowOTPVerify(false);
            }}
            show={showOTPVerify}
          />
        )}
        {showChangeMobileModal && (
          <ChangeMobileNumberModal
            onHide={() => {
              setShowChangeMobileModal(false);
            }}
            mode={hasMobileNumber ? "UPDATE" : "ADD"}
            onSave={(dialCode, mobile, country_code1) => {
              const cleanMobile = HelperService.removeDialCode(mobile, dialCode);
              setdial_Code(dialCode);
              setMoible_number(cleanMobile);
              setCountryCode(country_code1);
              setBasicDetails((prev: any) => ({
                ...prev,
                dial_code: dialCode,
                country_code: country_code1,
                mobile_number: cleanMobile,
                mobile_verified_at: new Date().toISOString(),
              }));
              if (impIds?.uuid) {
                getBasicDetails();
              }
            }}
            defaultDialCode={basicDetails?.dial_code}
            show={showChangeMobileModal}
          />
        )}

        {showEmail && (
          <ChangeEmailModal
            onHide={() => {
              setShowEmail(false);
            }}
            onSave={(email) => {
              setEmail(email);
              setShowEmail(false);
              setShowEmailOTPVerify(true);
            }}
            show={showEmail}
          />
        )}
        <VerifyEmailOTP
          email={email}
          handleHide={(flag) => {
            if (flag) {
              setBasicDetails((prev: any) => ({
                ...prev,
                email: email,
                email_verified_at: new Date(),
              }));
            }
            setShowEmailOTPVerify(false);
          }}
          show={showEmailOTPVerify}
        />
      </div>
    </>
  );
};

export default BasicDetailsWantToGrow;
